/* eslint-disable import/no-unused-modules, no-unused-vars */
import React from 'react';
import { Modal } from 'react-bootstrap';
import AddValuerForm from 'components/widgets/forms/setup/Add_Valuer';

function AddValuer(props) {
  return (
    <div>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h5 className="text-grey">Add a Valuer</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AddValuerForm {...props} />
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default AddValuer;
